export default __webpack_public_path__ + "static/article-the-pros-and-cons-of-new-and-used-cars-4006c861be5df2c8ea7e90fd3cff59ad.jpg";